import React, { Fragment } from "react";
import { Tab } from "@headlessui/react";
import { classNames } from "utils/utils";
import { useGame } from "context/gameContext";
import { useTranslation } from "react-i18next";
import { useLeague } from "context/leagueContext";

const RoundTab = ({
  id,
  header,
  title,
  subTitle,
  label,
  settled,
  highlighted,
  labelStatus,
}) => {
  const {
    state: { theme },
  } = useGame();

  const {
    state: { leagueInfo },
  } = useLeague();

  const { t, i18n } = useTranslation();

  const isKnockout = leagueInfo?.gameRule == 2;

  const outcomeButtonClassNames = [];

  if (settled) {
    if (labelStatus == 1) {
      outcomeButtonClassNames.push("bg-customGreen text-black");
    } else if (labelStatus == 2) {
      outcomeButtonClassNames.push("bg-yellow-500 text-black");
    } else if (labelStatus == 3) {
      outcomeButtonClassNames.push("bg-red-500 text-white");
    } else {
      outcomeButtonClassNames.push("bg-white");
    }
  } else {
    outcomeButtonClassNames.push("bg-gray-200");
  }

  const outcomeButtonClassNamesResult = outcomeButtonClassNames.join(" ");

  return (
    <Tab as={Fragment}>
      {({ selected }) => (
        <div
          key={id}
          className={classNames(
            selected
              ? "bg-textPrimary"
              : theme?.id === 0
              ? "bg-white/80"
              : "bg-white/40",
            highlighted && "border-2 border-textPrimary",
            settled ? "shadow-none " : "shadow-lg",
            "flex justify-between items-center flex-col flex-shrink-0 w-24 overflow-hidden p-2 text-md font-medium text-black rounded-lg focus:outline-none group-last:last:pr-2 cursor-pointer"
          )}
        >
          <div className="flex justify-center items-center flex-col w-full overflow-hidden">
            <div
              className={classNames(
                theme?.id === 0
                  ? selected
                    ? "text-textSecondary"
                    : "text-textPrimary"
                  : "",
                "text-sm h-fit"
              )}
            >
              {header}
            </div>

            <div
              className={classNames(
                isKnockout ? "w-16 h-12" : "w-10 max-h-10 h-10",
                "flex justify-center items-center   mt-1"
              )}
            >
              <div
                className={classNames(
                  settled
                    ? theme?.id === 0
                      ? "bg-gray-200 text-black "
                      : " text-black bg-white "
                    : "bg-gray-200 text-black",
                  settled && selected && "bg-gray-200",
                  isKnockout
                    ? theme?.id === 0
                      ? "rounded-md h-full w-full flex justify-center items-center bg-gray-100"
                      : "rounded-md h-full w-full flex justify-center items-center bg-white/30"
                    : "rounded-full w-10 h-10 flex justify-center items-center",
                  selected && isKnockout
                    ? theme?.id === 0
                      ? "!text-white !bg-white/30"
                      : "!text-black !bg-gray-100"
                    : "",
                  "flex-col "
                )}
              >
                <div className="text-xs font-normal">{title ? title : "-"}</div>
                {isKnockout && subTitle && (
                  <div className="grid items-center px-2">
                    <div className="truncate font-light text-xs">
                      {subTitle}
                    </div>
                  </div>
                )}
              </div>
            </div>
            <div className="w-full mt-2">
              <div
                className={classNames(
                  //selected ? "bg-gray-200" : "bg-white",
                  outcomeButtonClassNamesResult,
                  theme?.id === 0
                    ? selected
                      ? "text-black"
                      : "text-textPrimary"
                    : "",
                  "text-xs truncate rounded-md px-2 py-0.5 text-center "
                )}
              >
                {label}
              </div>
            </div>
          </div>
        </div>
      )}
    </Tab>
  );
};

export default RoundTab;
